import React, { Component } from 'react'
import Input from '../../components/form/Input'

import './passwordInput.scss'

class PasswordInput extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showPwd: false,
        }
    }

    render() {
        const {
            cssClass, style, value, onChange, name, id, label, placeholder,
            register, unregister, emptyError, isMandatory,
        } = this.props
        const { showPwd } = this.state
        return (
            <div className="pwd-container">
                <Input
                    type={showPwd ? 'text' : 'password'}
                    name={name}
                    id={id}
                    label={label}
                    cssClass={cssClass}
                    style={style}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    register={register}
                    unregister={unregister}
                    emptyError={emptyError}
                    isMandatory={isMandatory}
                />
                <i
                    className={`mask ${showPwd ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'}`}
                    onClick={() => {
                        this.setState((prevState) => ({
                            showPwd: !prevState.showPwd,
                        }))
                    }}
                />
            </div>
        )
    }
}

export default PasswordInput
